export const CLASS_NAMES = {
  outerWrapper: 'relative w-full max-w-120 mx-auto',
  wrapper: 'flex flex-col items-center justify-center gap-y-4 py-6',
  wrapperNoTrustPilot:
    'flex flex-col items-center justify-center gap-y-4 pt-6 mb-2',
  logoWrapper: '',
  help: 'absolute top-4 right-4',
  close: 'absolute top-4 left-4',
  trustPilot: 'w-40',
};
